__turbopack_context__.v({
  "accountInfo": "styles-module-scss-module__gmCYFG__accountInfo",
  "menuContainer": "styles-module-scss-module__gmCYFG__menuContainer",
  "root": "styles-module-scss-module__gmCYFG__root",
});
